// Vendor
import React, { Component } from 'react';
// import { Link } from 'react-router-dom'
import Link from 'next/link';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import ReactHtmlParser from 'react-html-parser';
import cn from 'classnames';
// Components
import AppLink from '../../components/AppLink';

// Root Styles
import '../../styles/document.styl';
// Styles
import './style.styl';

class Author extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { className, author } = this.props;
    const isAuthor = !!(author && Object.keys(author).length);
    const { avatar, name, position, company, profile_fb } = author;

    const classWrapperBlock = cn({
      Author: true,
      [`${className}`]: className,
    });

    return (
      <section className={classWrapperBlock}>
        {isAuthor && (
          <div className="Author__content">
            <AppLink className="Author__back" href={`/`}>
              К общей ленте
            </AppLink>
            <div className="Author__info">
              <div className="Author__author-visual">
                <div className="Author__avatar">
                  {avatar && <img className="Author__avatar-img" src={avatar} />}
                  {!avatar && (
                    <img className="Author__avatar-img" src="/static/images/icons/avatar.svg" />
                  )}
                </div>
                {profile_fb && (
                  <a
                    className="Author__profile Author__profile_fb"
                    href={profile_fb}
                    target="_blank"
                  />
                )}
              </div>

              <div className="Author__author-text">
                <div className="Author__author-name">{name}</div>
                <div className="Author__author-position">
                  {position}
                  {position && company && ' в '}
                  {company}
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    );
  }
}

Author.defaultProps = {
  className: '',
  author: null,
};

Author.propTypes = {
  className: PropTypes.string,
  author: PropTypes.object,
};

export default Author;



// WEBPACK FOOTER //
// components/Author/index.js